import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5132f497&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&id=5132f497&prod&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&id=5132f497&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132f497",
  null
  
)

export default component.exports